import styled from "styled-components";
import { Box } from "theme-ui";

export const CardContainer = styled(Box)`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  height: 100%;
`;

export const CardBackground = styled.div`
  position: absolute;
  inset: 0;
  background-color: #ffffff;
  border-radius: 6px;
  box-shadow: 0px 0px 12px 4px rgba(129, 129, 129, 0.07);
`;

export const CardBody = styled.div`
  position: relative;
  flex: 1;
  padding: 20px;
  z-index: 1;
`;
